import { useState, memo, Fragment, useEffect } from "react";

//React-bootstrap
import { Image, Dropdown, Form, FormCheck, Button } from "react-bootstrap";

//Components
import Card from "../../../../components/bootstrap/card";
import { findIcon } from "../../../dashboard/icons";
import article_1 from "../../../../assets/modules/file-manager/images/article_1.jpg";
import dayjs from "dayjs";
import FilePreviewModal from "../../../../components/partials/common/file-preview-modal";
const ContentCard = ({
  id,
  src,
  date,
  title,
  description,
  titleHtml,
  descriptionHtml,
  citation = "",
  createdBy,
  brand,
  type,
  onSelect,
  checked = false,
  icon = "",
  onClickPreview,
  coverImage = "",
  file = "",
  filePreviewModal = false,
  onViewModalClose,
}) => {
  const fileTypes = [
    "pdf",
    "doc",
    "article",
    "audio",
    "zip",
    "html",
    "ppt",
    "email",
    "docx",
    "video",
  ];
  console.log("step", id);
  return (
    <Fragment>
      <Card className="position-relative overflow-hidden">
        <Card.Body className="p-3">
          {onSelect && typeof onSelect === "function" && (
            <div className="position-absolute avatar-60 lh-1 fileselect-check-box">
              <Form.Check className="m-0 p-0 w-100 h-100 rounded-circle overflow-hidden form-check">
                <span className="position-absolute translate-middle top-50 start-50  text-secondary check-mark">
                  {findIcon("Check", "outline", "16")}
                </span>

                <FormCheck.Input
                  type="checkbox"
                  className=""
                  id="exampleCheck1"
                  onChange={() => onSelect(id)}
                  checked={checked}
                />
              </Form.Check>
            </div>
          )}
          <div className="p-3 d-flex justify-content-center align-items-center rounded bg-light flex-shrink-0">
            <Image
              src={src || icon || article_1}
              className="img-fluid icon-60"
              alt=""
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = article_1;
              }}
            />
          </div>

          <div className="mt-3">
            <div className="d-flex align-items-start mb-2 gap-2">
              <div className="avatar-36 bg-soft-primary lh-1 d-flex align-items-center justify-content-center flex-shrink-0">
                {type == "image"
                  ? findIcon("Photograph", "dual-tone", "24")
                  : type == "video"
                  ? findIcon("Start", "dual-tone", "24")
                  : findIcon("Document", "dual-tone", "24")}
              </div>
              <div className="flex-grow-1 fs-6 text-truncate">
                <h5 className="text-dark mb-1 small text-truncate">
                  {title || "Title"}
                </h5>

                <p className="fs-7 mb-0 lh-sm">
                  {date ? dayjs(date).format("DD MMM YYYY") : ""}
                </p>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              {/* <span className="small mb-0 me-2 text-info">{props.imgMb}</span> */}
              <div className="d-flex justify-content-end align-items-center gap-2 ms-auto">
                <Button
                  variant="outline-primary"
                  className="p-0 icon-32 d-flex align-items-center justify-content-center rounded-circle"
                  onClick={() => onClickPreview(id)}
                >
                  {findIcon("Eye", "solid", "16")}
                </Button>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
      {filePreviewModal && (
        <FilePreviewModal
          id={id}
          mediaType={type}
          show={filePreviewModal}
          viewModalClose={() => onViewModalClose(id)}
          title={title}
          titleHtml={titleHtml}
          descriptionHtml={descriptionHtml}
          citation={citation}
          coverImage={coverImage}
          brand={brand}
          createdOn={date}
          createdBy={createdBy}
          description={description}
          icon={icon}
          file_url={file}
          onSelect={onSelect}
        />
      )}
    </Fragment>
  );
};

ContentCard.displayName = "ContentCard";
export default memo(ContentCard);
